"use client"

import { motion } from "motion/react"

import { BreadcrumbComponent } from "@/components/ui/breadcrumb"
import { FADE_UP, FADE_TRANSITION } from "@/lib/motion-presets"

interface BlogPageHeroProps {
  children: React.ReactNode
}

export function BlogPageHero({ children }: BlogPageHeroProps) {
  return (
    <div className="min-h-screen relative">
      <div className="relative">
        <motion.div
          {...FADE_UP}
          transition={FADE_TRANSITION}
          className="max-w-6xl mx-auto px-4 pt-6 md:pt-8 md:px-6 lg:px-8"
        >
          <BreadcrumbComponent items={[{ label: "Home", href: "/" }, { label: "Lawn Care Tips & Resources" }]} />
        </motion.div>

        {/* Page heading + search live inside BlogListingClient so they can share state with the filter bar. */}
        {children}
      </div>
    </div>
  )
}
